import { createFileRoute } from '@tanstack/react-router'
import { MyDriveContent } from '@/components/my-drive'

export const Route = createFileRoute('/(app)/productivity/my-drive/')({
  component: MyDrivePage,
})

function MyDrivePage() {
  return <MyDriveContent />
}
